<div class="color-menu-container">
  <div (click)="$event.stopPropagation()">
    <div class="cta-container">
      <button (click)="onTabClick()" [class.active]="isShowCustom">
        <span class="text">Custom</span>
      </button>
      <button (click)="onTabClick(false)" [class.active]="!isShowCustom">
        <span class="text">Palette</span>
      </button>
    </div>

    <div class="color-options-container">
      <ng-container *ngIf="isShowCustom">
        <mode-color-picker-container
          [currentColor]="activeColor"
          [savedColor]="savedColor"
          (colorUpdated)="onColorSelected($event)"
          [updateOnMove]="updateOnMove"
        ></mode-color-picker-container>
      </ng-container>

      <ng-container *ngIf="!isShowCustom">
        <mode-color-swatch-selector
          [activeColor]="activeColor"
          [selectedColorPalette]="currentPalette"
          [allColorPalettes]="allColorPalettes"
          (paletteChanged)="onPaletteChanged($event)"
          (swatchClicked)="onColorSelected($event.colorSelected, $event.selectedPalette)"
        ></mode-color-swatch-selector>
      </ng-container>

      <mode-background-settings-toggle
        [showTextSettings]="showTextSettings"
        [enableTextSettings]="enableTextSettings"
        [isUseAsBackground]="isUseAsBackground"
        (markTargetUpdated)="onMarkTargetClick($event)"
      ></mode-background-settings-toggle>
    </div>
  </div>
</div>
